import { List, Table, useMediaQueryContext, } from '@fourthwall/components';
import React from 'react';
export const AnalyticsReportsData = ({ list, table }) => {
    const media = useMediaQueryContext();
    if (!media.tablet) {
        return React.createElement(List, { ...list });
    }
    return React.createElement(Table, { ...table });
};
